import { render, staticRenderFns } from "./Epitelium.vue?vue&type=template&id=6bf8f18a&scoped=true"
import script from "./Epitelium.vue?vue&type=script&lang=js"
export * from "./Epitelium.vue?vue&type=script&lang=js"
import style0 from "./Epitelium.vue?vue&type=style&index=0&id=6bf8f18a&prod&lang=scss&scoped=true"
import style1 from "./Epitelium.vue?vue&type=style&index=1&id=6bf8f18a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8f18a",
  null
  
)

export default component.exports